import { render } from "./NotFound.vue?vue&type=template&id=74da65ee&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=74da65ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74da65ee"

export default script